/* Skincare product page components. Sections may include this file more than once, so it guards itself. */
(() => {
  if (window.skinPdpLoaded) return;
  window.skinPdpLoaded = true;

  const SkinMoney = {
    format(cents, format) {
      const fmt = format || window.skinMoneyFormat || '{{amount}}';
      const value = (Number(cents) || 0) / 100;
      const group = (num, decimals, thousands, decimal) => {
        const [whole, frac] = num.toFixed(decimals).split('.');
        const withSep = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return frac ? `${withSep}${decimal}${frac}` : withSep;
      };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount_no_decimals':
            return group(value, 0, ',', '.');
          case 'amount_with_comma_separator':
            return group(value, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return group(value, 0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return group(value, 2, "'", '.');
          default:
            return group(value, 2, ',', '.');
        }
      });
    },
    // Rounded to whole units with no decimals, e.g. Rs. 2,999 instead of Rs. 2,998.80
    formatWhole(cents) {
      const fmt = (window.skinMoneyFormat || '{{amount}}')
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}')
        .replace(/\{\{\s*amount\s*\}\}/, '{{amount_no_decimals}}');
      return this.format(Math.round((Number(cents) || 0) / 100) * 100, fmt);
    },
  };

  function skinSubscribeVariantChange(sectionId, callback) {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return null;
    return subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data.sectionId !== sectionId || !event.data.variant) return;
      callback(event.data.variant);
    });
  }

  function skinAddToCart(items, button) {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items };
    if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      cart.setActiveElement?.(button);
    }

    return fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message);
        const firstItem = response.items?.[0] || {};
        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'skin-pdp', productVariantId: firstItem.id, cartData: response });
        }
        if (!cart) {
          window.location = routes.cart_url;
          return;
        }
        cart.classList.remove('is-empty');
        cart.renderContents({ ...response, id: firstItem.id, key: firstItem.key });
      });
  }

  /* Delivery estimate: "Get it by Thu, 9 Oct" (skips Sundays). With a dispatch
     cutoff (India time) it counts down to today's cutoff: "Order within 2h 14m · Get it by …";
     after the cutoff (and on Sundays) dates count from the next dispatch day. */
  const IST_OFFSET = 330 * 60000;

  // Next dispatch moment, read with getUTC* methods (dates are shifted to India time).
  // `countdown` is "2h 14m" until today's cutoff, otherwise null.
  function skinDispatch(cutoff) {
    const now = new Date(Date.now() + IST_OFFSET);
    const start = new Date(now);
    if (!cutoff) return { start, countdown: null };
    start.setUTCHours(cutoff, 0, 0, 0);
    while (start <= now || start.getUTCDay() === 0) start.setUTCDate(start.getUTCDate() + 1);
    if (start.getUTCDate() !== now.getUTCDate()) return { start, countdown: null };
    const minutes = Math.max(1, Math.ceil((start - now) / 60000));
    const hours = Math.floor(minutes / 60);
    return { start, countdown: hours ? `${hours}h ${minutes % 60}m` : `${minutes}m` };
  }

  function skinFormatDelivery(el) {
    const { start, countdown } = skinDispatch(parseInt(el.dataset.cutoff, 10) || 0);

    const addBusinessDays = (days) => {
      const date = new Date(start);
      let added = 0;
      while (added < days) {
        date.setUTCDate(date.getUTCDate() + 1);
        if (date.getUTCDay() !== 0) added += 1;
      }
      return date;
    };
    const fmt = (d) =>
      d.toLocaleDateString(document.documentElement.lang || 'en-IN', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        timeZone: 'UTC',
      });
    const min = parseInt(el.dataset.min, 10) || 2;
    const max = parseInt(el.dataset.max, 10) || 5;
    const range = min === max ? fmt(addBusinessDays(max)) : `${fmt(addBusinessDays(min))} – ${fmt(addBusinessDays(max))}`;
    el.textContent = range;

    const cutoffEl = el.closest('.skin-trust__delivery')?.querySelector('[data-skin-cutoff]');
    if (!cutoffEl) return;
    cutoffEl.hidden = !countdown;
    if (countdown) cutoffEl.querySelector('[data-skin-cutoff-time]').textContent = countdown;
  }

  /* Urgency line, when stock isn't low: "Order within 2h 14m for same-day dispatch".
     Hidden after the cutoff and on Sundays. */
  function skinFormatUrgency(el) {
    const { countdown } = skinDispatch(parseInt(el.dataset.cutoff, 10) || 0);
    const line = el.closest('.skin-urgency');
    line.classList.toggle('hidden', !countdown);
    if (countdown) el.textContent = el.dataset.template.replace('[time]', countdown);
  }

  const skinFormatTimers = (root = document) => {
    root.querySelectorAll('[data-skin-delivery]').forEach(skinFormatDelivery);
    root.querySelectorAll('[data-skin-urgency-cutoff]').forEach(skinFormatUrgency);
  };
  skinFormatTimers();
  setInterval(skinFormatTimers, 30000);
  document.addEventListener('shopify:section:load', (event) => skinFormatTimers(event.target));

  /* Urgency line: swap in the selected variant's stock message */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const id = `SkinUrgency-${data.sectionId}`;
      const source = data.html?.getElementById(id);
      const destination = document.getElementById(id);
      if (!source || !destination) return;
      destination.innerHTML = source.innerHTML;
      destination.className = source.className;
      skinFormatTimers(destination);
    });
  }

  /* Quantity bundles */
  if (!customElements.get('skin-bundle')) {
    customElements.define(
      'skin-bundle',
      class SkinBundle extends HTMLElement {
        connectedCallback() {
          this.formId = this.dataset.form;
          this.addEventListener('change', (event) => {
            if (event.target.matches('input[type="radio"]')) this.applyQuantity();
          });
          this.unsubscribe = skinSubscribeVariantChange(this.dataset.section, (variant) => this.updatePrices(variant));
          if (!this.selected) {
            const first = this.querySelector('input[type="radio"]');
            if (first) first.checked = true;
          }
          this.applyQuantity();
        }

        disconnectedCallback() {
          this.unsubscribe?.();
        }

        get selected() {
          return this.querySelector('input[type="radio"]:checked');
        }

        applyQuantity() {
          const qty = this.selected?.value || '1';
          document.querySelectorAll(`input[name="quantity"][form="${this.formId}"]`).forEach((input) => {
            input.value = qty;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          const discount = Number(this.selected?.dataset.discount) || 0;
          document.dispatchEvent(
            new CustomEvent('skin:bundle-change', { detail: { formId: this.formId, qty: Number(qty), discount } })
          );
        }

        updatePrices(variant) {
          const unitPrice = variant.price;
          const unitCompare = Math.max(variant.compare_at_price || 0, unitPrice);
          this.querySelectorAll('[data-bundle-option]').forEach((option) => {
            const input = option.querySelector('input');
            const qty = Number(input.value);
            const discount = Number(input.dataset.discount) || 0;
            const full = unitPrice * qty;
            const total = Math.round(full - (full * discount) / 100);
            const compare = unitCompare * qty;
            option.querySelector('[data-bundle-total]').textContent = SkinMoney.formatWhole(total);
            const compareEl = option.querySelector('[data-bundle-compare]');
            if (compareEl) {
              compareEl.textContent = SkinMoney.formatWhole(compare);
              compareEl.hidden = compare <= total;
            }
            const pill = option.querySelector('[data-bundle-pill]');
            if (pill) {
              const percent = compare > total ? Math.round(((compare - total) * 100) / compare) : 0;
              pill.textContent = pill.dataset.label.replace('[percent]', percent);
              pill.hidden = percent <= 0;
            }
          });
        }
      }
    );
  }

  /* Frequently bought together */
  if (!customElements.get('skin-fbt')) {
    customElements.define(
      'skin-fbt',
      class SkinFbt extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-fbt-submit]');
          this.error = this.querySelector('[data-fbt-error]');
          this.addEventListener('change', () => this.update());
          this.button?.addEventListener('click', () => this.submit());
          this.unsubscribe = skinSubscribeVariantChange(this.dataset.section, (variant) => {
            const main = this.querySelector('[data-fbt-main]');
            if (!main) return;
            main.dataset.variantId = variant.id;
            main.dataset.price = variant.price;
            main.dataset.compare = Math.max(variant.compare_at_price || 0, variant.price);
            main.disabled = !variant.available;
            if (!variant.available) main.checked = false;
            const price = this.querySelector('[data-fbt-main-price]');
            if (price) price.textContent = SkinMoney.format(variant.price);
            this.update();
          });
          this.update();
        }

        disconnectedCallback() {
          this.unsubscribe?.();
        }

        get checked() {
          return [...this.querySelectorAll('input[data-variant-id]:checked')];
        }

        update() {
          const checked = this.checked;
          const total = checked.reduce((sum, input) => sum + Number(input.dataset.price), 0);
          const compare = checked.reduce((sum, input) => sum + Number(input.dataset.compare), 0);
          this.querySelector('[data-fbt-total]').textContent = SkinMoney.format(total);
          const compareEl = this.querySelector('[data-fbt-compare]');
          compareEl.textContent = SkinMoney.format(compare);
          compareEl.hidden = compare <= total;
          this.querySelectorAll('[data-fbt-thumb]').forEach((thumb) => {
            const input = this.querySelector(`#${thumb.dataset.fbtThumb}`);
            thumb.classList.toggle('is-off', !input?.checked);
          });
          const count = this.querySelector('[data-fbt-count]');
          if (count) count.textContent = checked.length;
          this.button.disabled = checked.length === 0;
        }

        submit() {
          const items = this.checked.map((input) => ({ id: Number(input.dataset.variantId), quantity: 1 }));
          if (!items.length) return;
          this.error.hidden = true;
          const spinner = this.button.querySelector('.loading__spinner');
          this.button.classList.add('loading');
          this.button.setAttribute('aria-busy', 'true');
          spinner?.classList.remove('hidden');
          skinAddToCart(items, this.button)
            .catch((error) => {
              this.error.textContent = error.message;
              this.error.hidden = false;
            })
            .finally(() => {
              this.button.classList.remove('loading');
              this.button.removeAttribute('aria-busy');
              spinner?.classList.add('hidden');
            });
        }
      }
    );
  }

  /* Sticky add to cart bar */
  if (!customElements.get('skin-sticky-atc')) {
    customElements.define(
      'skin-sticky-atc',
      class SkinStickyAtc extends HTMLElement {
        connectedCallback() {
          this.formId = this.dataset.form;
          this.button = this.querySelector('[data-sticky-submit]');
          const target = document.getElementById(this.dataset.watch);
          if (target) {
            this.observer = new IntersectionObserver(
              ([entry]) => {
                const above = entry.boundingClientRect.top < 0;
                this.classList.toggle('is-visible', !entry.isIntersecting && above);
              },
              { threshold: 0 }
            );
            this.observer.observe(target);
          }
          this.unitPrice = Number(this.dataset.price);
          this.qty = 1;
          this.unsubscribe = skinSubscribeVariantChange(this.dataset.section, (variant) => {
            this.unitPrice = variant.price;
            this.querySelector('[data-sticky-variant]').textContent = variant.title === 'Default Title' ? '' : variant.title;
            this.button.disabled = !variant.available;
            this.button.querySelector('[data-sticky-label]').textContent = variant.available
              ? this.button.dataset.label
              : window.variantStrings?.soldOut || 'Sold out';
            this.refreshPrice();
          });
          this.onBundle = (event) => {
            if (event.detail.formId !== this.formId) return;
            this.qty = event.detail.qty;
            this.refreshPrice();
          };
          document.addEventListener('skin:bundle-change', this.onBundle);
          const initialBundle = document.querySelector(`skin-bundle[data-form="${this.formId}"] input:checked`);
          if (initialBundle) {
            this.qty = Number(initialBundle.value) || 1;
            this.refreshPrice();
          }

          // Feedback on tap: loading spinner, then a short "Added to bag" confirmation
          this.button.addEventListener('click', () => {
            if (this.button.disabled) return;
            this.setState('loading');
            clearTimeout(this.safety);
            this.safety = setTimeout(() => this.setState(''), 8000);
          });
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubCart = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              if (!this.classList.contains('is-loading') || event.source !== 'product-form') return;
              this.setState('added');
              clearTimeout(this.safety);
              this.safety = setTimeout(() => this.setState(''), 1800);
            });
            this.unsubError = subscribe(PUB_SUB_EVENTS.cartError, () => {
              if (this.classList.contains('is-loading')) this.setState('');
            });
          }
        }

        setState(state) {
          this.classList.toggle('is-loading', state === 'loading');
          this.classList.toggle('is-added', state === 'added');
          this.button.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
        }

        refreshPrice() {
          const bundleInput = document.querySelector(`skin-bundle[data-form="${this.formId}"] input:checked`);
          const discount = Number(bundleInput?.dataset.discount) || 0;
          const full = this.unitPrice * this.qty;
          this.querySelector('[data-sticky-price]').textContent = SkinMoney.format(Math.round(full - (full * discount) / 100));
          const qtyEl = this.querySelector('[data-sticky-qty]');
          if (qtyEl) {
            qtyEl.textContent = `× ${this.qty}`;
            qtyEl.hidden = this.qty <= 1;
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.unsubscribe?.();
          this.unsubCart?.();
          this.unsubError?.();
          clearTimeout(this.safety);
          document.removeEventListener('skin:bundle-change', this.onBundle);
        }
      }
    );
  }

  /* Before / after comparison slider */
  if (!customElements.get('skin-before-after')) {
    customElements.define(
      'skin-before-after',
      class SkinBeforeAfter extends HTMLElement {
        connectedCallback() {
          const range = this.querySelector('input[type="range"]');
          const set = () => this.style.setProperty('--skin-ba-position', `${range.value}%`);
          range.addEventListener('input', set);
          set();
        }
      }
    );
  }

  /* Count-up numbers for clinical results */
  if (!customElements.get('skin-count-up')) {
    customElements.define(
      'skin-count-up',
      class SkinCountUp extends HTMLElement {
        connectedCallback() {
          const text = this.textContent.trim();
          const match = text.match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);
          if (!match || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const [, prefix, number, suffix] = match;
          const target = parseFloat(number);
          const decimals = (number.split('.')[1] || '').length;
          const observer = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            const start = performance.now();
            const duration = 1400;
            const tick = (now) => {
              const progress = Math.min((now - start) / duration, 1);
              const eased = 1 - Math.pow(1 - progress, 3);
              this.textContent = `${prefix}${(target * eased).toFixed(decimals)}${suffix}`;
              if (progress < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          });
          this.textContent = `${prefix}${(0).toFixed(decimals)}${suffix}`;
          observer.observe(this);
        }
      }
    );
  }

  /* Reviews: filter, load more, photo lightbox */
  if (!customElements.get('skin-reviews')) {
    customElements.define(
      'skin-reviews',
      class SkinReviews extends HTMLElement {
        connectedCallback() {
          this.pageSize = Number(this.dataset.pageSize) || 6;
          this.shown = this.pageSize;
          this.filter = 'all';
          this.cards = [...this.querySelectorAll('[data-review]')];
          this.more = this.querySelector('[data-reviews-more]');
          this.dialog = this.querySelector('dialog');
          this.more?.addEventListener('click', () => {
            this.shown += this.pageSize;
            this.render();
          });
          this.querySelectorAll('[data-reviews-filter]').forEach((button) =>
            button.addEventListener('click', () => {
              this.filter = button.dataset.reviewsFilter;
              this.shown = this.pageSize;
              this.querySelectorAll('[data-reviews-filter]').forEach((b) =>
                b.setAttribute('aria-pressed', String(b === button))
              );
              this.render();
            })
          );
          this.list = this.querySelector('[data-reviews-list]');
          this.querySelector('[data-reviews-sort]')?.addEventListener('change', (event) => this.sort(event.target.value));
          this.querySelectorAll('[data-review-photo]').forEach((photo) =>
            photo.addEventListener('click', () => this.openPhoto(photo))
          );
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog || event.target.closest('[data-lightbox-close]')) this.dialog.close();
          });
          this.render();
        }

        render() {
          let visible = 0;
          this.cards.forEach((card) => {
            const matches =
              this.filter === 'all' ||
              (this.filter === 'photos' && card.dataset.hasPhotos === 'true') ||
              card.dataset.rating === this.filter;
            const show = matches && visible < this.shown;
            if (matches) visible += 1;
            card.hidden = !show;
          });
          const total = this.cards.filter(
            (card) =>
              this.filter === 'all' ||
              (this.filter === 'photos' && card.dataset.hasPhotos === 'true') ||
              card.dataset.rating === this.filter
          ).length;
          if (this.more) this.more.hidden = this.shown >= total;
          const empty = this.querySelector('[data-reviews-empty]');
          if (empty) empty.hidden = total > 0;
        }

        sort(mode) {
          const by = {
            recent: (a, b) => Number(b.dataset.date) - Number(a.dataset.date),
            highest: (a, b) => Number(b.dataset.rating) - Number(a.dataset.rating),
            lowest: (a, b) => Number(a.dataset.rating) - Number(b.dataset.rating),
          }[mode];
          this.cards.sort((a, b) => (by && by(a, b)) || Number(a.dataset.order) - Number(b.dataset.order));
          this.cards.forEach((card) => this.list.appendChild(card));
          this.shown = this.pageSize;
          this.render();
        }

        openPhoto(photo) {
          if (!this.dialog) return;
          // Build a brand-new <img> each time. Changing src on an existing image (or a clone,
          // which copies src) keeps the previous photo on screen until the new one downloads,
          // which on mobile looked like the wrong photo opening.
          const img = this.dialog.querySelector('img');
          const next = document.createElement('img');
          next.setAttribute('width', img.getAttribute('width') || 1400);
          next.setAttribute('height', img.getAttribute('height') || 1400);
          next.alt = photo.querySelector('img')?.alt || '';
          next.src = photo.dataset.full;
          img.replaceWith(next);
          if (!this.dialog.open) this.dialog.showModal();
        }
      }
    );
  }

  /* Price inside the main Add to cart button */
  (function skinButtonPrice() {
    const state = {};
    const render = (sectionId) => {
      const button = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const s = state[sectionId];
      if (!button || !s || !button.hasAttribute('data-skin-price')) return;
      const full = s.unit * s.qty;
      const total = Math.round(full - (full * s.discount) / 100);
      const priceEl = button.querySelector('[data-skin-btn-price]');
      if (!priceEl) return;
      // With packs on the page the button reads "Add to bag – X% OFF"; otherwise it shows the price
      const offLabel = button.dataset.skinOffLabel;
      const compare = Math.max(s.compare, s.unit) * s.qty;
      const percent = compare > total ? Math.round(((compare - total) * 100) / compare) : 0;
      priceEl.textContent = offLabel && percent > 0 ? offLabel.replace('[percent]', percent) : SkinMoney.format(total);
    };
    const init = () => {
      document.querySelectorAll('[id^="ProductSubmitButton-"][data-skin-price]').forEach((button) => {
        const sectionId = button.id.replace('ProductSubmitButton-', '');
        if (state[sectionId]) return;
        const sticky = document.querySelector(`skin-sticky-atc[data-section="${sectionId}"]`);
        const bundle = document.querySelector(`skin-bundle[data-section="${sectionId}"] input:checked`);
        state[sectionId] = {
          unit: Number(button.closest('product-info')?.querySelector('[data-skin-unit-price]')?.dataset.skinUnitPrice) ||
            Number(sticky?.dataset.price) || 0,
          qty: Number(bundle?.value) || 1,
          discount: Number(bundle?.dataset.discount) || 0,
          compare: Number(button.dataset.skinCompare) || 0,
        };
        if (state[sectionId].unit) render(sectionId);
        skinSubscribeVariantChange(sectionId, (variant) => {
          state[sectionId].unit = variant.price;
          state[sectionId].compare = variant.compare_at_price || 0;
          render(sectionId);
        });
      });
    };
    document.addEventListener('skin:bundle-change', (event) => {
      const sectionId = event.detail.formId.replace('product-form-', '');
      if (!state[sectionId]) return;
      state[sectionId].qty = event.detail.qty;
      state[sectionId].discount = event.detail.discount || 0;
      render(sectionId);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  /* Cycling highlight words */
  if (!customElements.get('skin-word-cycle')) {
    customElements.define(
      'skin-word-cycle',
      class SkinWordCycle extends HTMLElement {
        connectedCallback() {
          this.words = [...this.querySelectorAll('[data-word]')];
          if (this.words.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.index = 0;
          const interval = Number(this.dataset.interval) || 1800;
          this.timer = setInterval(() => {
            this.words[this.index].classList.remove('is-active');
            this.index = (this.index + 1) % this.words.length;
            this.words[this.index].classList.add('is-active');
          }, interval);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }
      }
    );
  }

  /* Generic tabs: [data-tab] buttons switch [data-panel] elements with the same value */
  if (!customElements.get('skin-tabs')) {
    customElements.define(
      'skin-tabs',
      class SkinTabs extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-tab]').forEach((tab) =>
            tab.addEventListener('click', () => this.select(tab.dataset.tab))
          );
        }

        select(value) {
          this.querySelectorAll('[data-tab]').forEach((tab) => {
            const active = tab.dataset.tab === value;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', String(active));
          });
          this.querySelectorAll('[data-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.panel !== value;
          });
        }
      }
    );
  }

  /* Step carousel (application / routine): [data-step-index] items, prev/next, thumbs */
  if (!customElements.get('skin-steps')) {
    customElements.define(
      'skin-steps',
      class SkinSteps extends HTMLElement {
        connectedCallback() {
          this.count = Number(this.dataset.count) || this.querySelectorAll('[data-step-text]').length;
          const initial = this.querySelector('[data-step-text].is-active');
          this.index = initial ? Number(initial.dataset.stepIndex) : 0;
          this.querySelector('[data-step-prev]')?.addEventListener('click', () => this.go(this.index - 1));
          this.querySelector('[data-step-next]')?.addEventListener('click', () => this.go(this.index + 1));
          this.querySelectorAll('[data-step-go]').forEach((el) =>
            el.addEventListener('click', () => this.go(Number(el.dataset.stepGo)))
          );
          this.querySelectorAll('[data-routine-add]').forEach((button) =>
            button.addEventListener('click', () => this.add(button))
          );
          this.go(this.index);
        }

        go(index) {
          this.index = (index + this.count) % this.count;
          this.querySelectorAll('[data-step-index]').forEach((el) => {
            const active = Number(el.dataset.stepIndex) === this.index;
            el.classList.toggle('is-active', active);
            if (el.hasAttribute('data-step-go')) el.setAttribute('aria-pressed', String(active));
          });
          const counter = this.querySelector('[data-step-counter]');
          if (counter) counter.textContent = String(this.index + 1).padStart(2, '0');
        }

        add(button) {
          const label = button.querySelector('[data-label]');
          button.classList.add('loading');
          button.setAttribute('aria-busy', 'true');
          skinAddToCart([{ id: Number(button.dataset.variantId), quantity: 1 }], button)
            .catch((error) => {
              if (label) label.textContent = error.message;
            })
            .finally(() => {
              button.classList.remove('loading');
              button.removeAttribute('aria-busy');
            });
        }
      }
    );
  }

  /* Dialog openers: <button data-skin-dialog="DialogId"> */
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-skin-dialog]');
    if (opener) {
      document.getElementById(opener.dataset.skinDialog)?.showModal();
      return;
    }
    const dialog = event.target.closest('dialog.skin-dialog');
    if (dialog && (event.target === dialog || event.target.closest('[data-skin-dialog-close]'))) dialog.close();
  });

  /* Horizontal carousel: scroll-snap track with arrows and a progress bar */
  if (!customElements.get('skin-carousel')) {
    customElements.define(
      'skin-carousel',
      class SkinCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-carousel-track]');
          this.bar = this.querySelector('[data-carousel-progress]');
          if (!this.track) return;
          this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.step(-1));
          this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.step(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          new ResizeObserver(() => this.update()).observe(this.track);
          this.update();
        }

        step(direction) {
          const slide = this.track.querySelector('.skin-carousel__slide');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth;
          this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const visible = this.track.clientWidth / this.track.scrollWidth;
          const progress = max > 0 ? this.track.scrollLeft / max : 0;
          this.classList.toggle('is-static', max <= 1);
          if (this.bar) {
            this.bar.style.width = `${Math.max(visible, 0.08) * 100}%`;
            this.bar.style.transform = `translateX(${(progress * (1 - visible) * 100) / Math.max(visible, 0.08)}%)`;
          }
          const prev = this.querySelector('[data-carousel-prev]');
          const next = this.querySelector('[data-carousel-next]');
          if (prev) prev.disabled = this.track.scrollLeft <= 1;
          if (next) next.disabled = this.track.scrollLeft >= max - 1;
        }
      }
    );
  }

  /* Quick add buttons on product cards */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-skin-quick-add]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    const label = button.querySelector('[data-label]');
    const original = label?.textContent;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');
    skinAddToCart([{ id: Number(button.dataset.variantId), quantity: 1 }], button)
      .catch((error) => {
        if (label) label.textContent = error.message;
        setTimeout(() => {
          if (label) label.textContent = original;
        }, 2500);
      })
      .finally(() => {
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
      });
  });

  /* Cart progress bar: animate from the previous fill level after each cart re-render */
  if (!customElements.get('skin-progress')) {
    customElements.define(
      'skin-progress',
      class SkinProgress extends HTMLElement {
        connectedCallback() {
          const fill = this.querySelector('.skin-cart-progress__fill');
          const target = Number(this.dataset.pct) || 0;
          const previous = typeof window.skinCartPct === 'number' ? window.skinCartPct : 0;
          window.skinCartPct = target;
          if (!fill || previous === target) return;
          fill.style.transition = 'none';
          fill.style.width = `${previous}%`;
          requestAnimationFrame(() =>
            requestAnimationFrame(() => {
              fill.style.transition = '';
              fill.style.width = `${target}%`;
            })
          );
        }
      }
    );
  }

  /* Upsell variant selects update their add button */
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-skin-variant-select]');
    if (!select) return;
    const button = select.closest('.skin-cart-upsell__card')?.querySelector('[data-skin-quick-add]');
    const option = select.selectedOptions[0];
    if (!button || !option) return;
    button.dataset.variantId = option.value;
    const label = button.querySelector('[data-label]');
    if (label) label.textContent = `${button.dataset.labelPrefix || ''} ${option.dataset.price}`.trim();
  });

  /* Collapse long product descriptions on mobile behind "Read more" */
  function initDescriptions(root = document) {
    root.querySelectorAll('.skin-pdp--bento .product__description').forEach((description) => {
      if (description.dataset.skinClamp || description.textContent.trim().length < 120) return;
      description.dataset.skinClamp = 'true';
      description.classList.add('is-clamped');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'skin-description-toggle';
      button.textContent = 'Read more';
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        const expanded = description.classList.toggle('is-expanded');
        button.textContent = expanded ? 'Read less' : 'Read more';
        button.setAttribute('aria-expanded', String(expanded));
      });
      description.appendChild(button);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initDescriptions());
  else initDescriptions();
  document.addEventListener('shopify:section:load', (event) => initDescriptions(event.target));

  /* Offer countdown (times are India Standard Time) */
  if (!customElements.get('skin-countdown')) {
    customElements.define(
      'skin-countdown',
      class SkinCountdown extends HTMLElement {
        connectedCallback() {
          this.end = this.getEnd();
          if (!this.end) return;
          this.timer = this.querySelector('.skin-offer__timer');
          this.tick();
          this.interval = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.interval);
        }

        getEnd() {
          const IST_OFFSET = 330 * 60 * 1000;
          if (this.dataset.mode === 'midnight') {
            const nowIst = new Date(Date.now() + IST_OFFSET);
            const midnightIst = Date.UTC(nowIst.getUTCFullYear(), nowIst.getUTCMonth(), nowIst.getUTCDate() + 1);
            return midnightIst - IST_OFFSET;
          }
          // Repeats every N hours, on fixed marks in India time (e.g. 12:00, 14:00, 16:00)
          if (this.dataset.mode === 'repeat') {
            const period = (parseInt(this.dataset.hours, 10) || 2) * 3600000;
            const nowIst = Date.now() + IST_OFFSET;
            return Math.floor(nowIst / period) * period + period - IST_OFFSET;
          }
          const match = (this.dataset.end || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
          if (!match) return null;
          const [, y, mo, d, h = '23', mi = '59'] = match;
          return Date.UTC(+y, +mo - 1, +d, +h, +mi) - IST_OFFSET;
        }

        tick() {
          const left = this.end - Date.now();
          if (left <= 0) {
            if (this.dataset.mode === 'midnight' || this.dataset.mode === 'repeat') {
              this.end = this.getEnd();
              return;
            }
            clearInterval(this.interval);
            this.hidden = true;
            return;
          }
          const total = Math.floor(left / 1000);
          const days = Math.floor(total / 86400);
          const pad = (n) => String(n).padStart(2, '0');
          const set = (unit, value) => {
            const el = this.querySelector(`[data-unit="${unit}"]`);
            if (el) el.textContent = value;
          };
          set('d', days);
          set('h', pad(Math.floor((total % 86400) / 3600)));
          set('m', pad(Math.floor((total % 3600) / 60)));
          set('s', pad(total % 60));
          const daysUnit = this.querySelector('[data-days-unit]');
          if (daysUnit) daysUnit.hidden = days === 0;
          const hoursUnit = this.querySelector('[data-hours-unit]');
          if (hoursUnit) hoursUnit.hidden = total < 3600;
          this.timer.hidden = false;
        }
      }
    );
  }

  /* Reveal-on-scroll hook: adds .is-visible to [data-skin-reveal] once in view */
  const revealObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) =>
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }),
          { threshold: 0.25 }
        )
      : null;
  function initReveal(root = document) {
    root.querySelectorAll('[data-skin-reveal]:not(.is-visible)').forEach((el) => {
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('is-visible');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initReveal());
  else initReveal();
  document.addEventListener('shopify:section:load', (event) => initReveal(event.target));

  /* Video reels: play muted while visible, tap to toggle sound */
  if (!customElements.get('skin-reel')) {
    customElements.define(
      'skin-reel',
      class SkinReel extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;
          this.video.muted = true;
          this.video.loop = true;
          this.video.playsInline = true;
          this.video.removeAttribute('controls');
          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) this.video.play().catch(() => {});
              else this.video.pause();
            },
            { threshold: 0.6 }
          );
          this.observer.observe(this);
          this.querySelector('[data-reel-sound]')?.addEventListener('click', () => this.toggleSound());
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        toggleSound() {
          const unmute = this.video.muted;
          document.querySelectorAll('skin-reel video').forEach((video) => {
            video.muted = true;
            video.closest('skin-reel')?.classList.remove('is-unmuted');
          });
          this.video.muted = !unmute;
          this.classList.toggle('is-unmuted', unmute);
          if (unmute) this.video.play().catch(() => {});
        }
      }
    );
  }

  // FAQ + buy box accordions: animate height on open and close
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.skin-faq__item > summary, .skin-buy-card .product__accordion details > summary');
    if (!summary) return;
    const details = summary.parentElement;
    const content = details.querySelector(':scope > .skin-faq__answer, :scope > .accordion__content');
    if (!content || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    event.preventDefault();
    if (details.dataset.animating) return;
    details.dataset.animating = 'true';

    const finish = () => {
      content.removeEventListener('transitionend', onEnd);
      clearTimeout(fallback);
      if (details.classList.contains('is-closing')) details.open = false;
      details.classList.remove('is-closing');
      content.style.height = '';
      delete details.dataset.animating;
    };
    const onEnd = (e) => {
      if (e.target === content && e.propertyName === 'height') finish();
    };
    const fallback = setTimeout(finish, 600);
    content.addEventListener('transitionend', onEnd);

    if (details.open) {
      content.style.height = `${content.scrollHeight}px`;
      content.offsetHeight; // eslint-disable-line no-unused-expressions
      details.classList.add('is-closing');
      content.style.height = '0px';
    } else {
      details.open = true;
      const height = content.scrollHeight;
      content.style.height = '0px';
      content.offsetHeight; // eslint-disable-line no-unused-expressions
      content.style.height = `${height}px`;
    }
  });

  /* Cart drawer: reservation countdown, kept for the browser session */
  if (!customElements.get('skin-cart-timer')) {
    customElements.define(
      'skin-cart-timer',
      class SkinCartTimer extends HTMLElement {
        connectedCallback() {
          this.time = this.querySelector('[data-timer]');
          this.duration = (parseInt(this.dataset.minutes, 10) || 10) * 60000;
          this.tick();
          this.interval = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.interval);
        }

        getEnd() {
          let end = 0;
          try {
            end = parseInt(sessionStorage.getItem('skinCartReserveEnd'), 10) || 0;
          } catch (e) {}
          if (end <= Date.now()) {
            end = Date.now() + this.duration;
            try {
              sessionStorage.setItem('skinCartReserveEnd', String(end));
            } catch (e) {}
          }
          return end;
        }

        tick() {
          const left = Math.max(0, this.getEnd() - Date.now());
          const minutes = Math.floor(left / 60000);
          const seconds = Math.floor((left % 60000) / 1000);
          if (this.time) this.time.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        }
      }
    );
  }

  /* "Estimated delivery by Mon, 12 Oct": today + N calendar days */
  if (!customElements.get('skin-delivery-date')) {
    customElements.define(
      'skin-delivery-date',
      class SkinDeliveryDate extends HTMLElement {
        connectedCallback() {
          const date = new Date();
          date.setDate(date.getDate() + (parseInt(this.dataset.days, 10) || 7));
          this.textContent = date.toLocaleDateString(document.documentElement.lang || 'en-IN', {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
          });
        }
      }
    );
  }

  /* Desktop product page: each column sticks; a column taller than the window
     scrolls until its bottom is visible, then stays until the section ends.
     The gallery sits in the vertical middle of the space below the header, and
     both columns move down while the sticky header is showing so it never covers them. */
  function skinStickyColumns() {
    const columns = document.querySelectorAll('.skin-pdp--bento .product__media-wrapper, .skin-pdp--bento .product__info-wrapper');
    if (!columns.length) return;
    const header = document.querySelector('.section-header');
    const gap = 24;
    const headerSpace = () => {
      if (!header) return 0;
      const showing =
        header.classList.contains('shopify-section-header-sticky') &&
        !header.classList.contains('shopify-section-header-hidden');
      return showing ? header.offsetHeight : 0;
    };
    const update = () => {
      const offset = headerSpace();
      columns.forEach((column) => {
        const free = window.innerHeight - offset - column.offsetHeight;
        const centred = column.classList.contains('product__media-wrapper') ? Math.round(free / 2) : gap;
        const top = offset + Math.min(Math.max(gap, centred), free - gap);
        column.style.setProperty('--skin-sticky-top', `${top}px`);
      });
    };
    update();
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(update);
      columns.forEach((column) => observer.observe(column));
    }
    if (header) new MutationObserver(update).observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', skinStickyColumns);
  } else {
    skinStickyColumns();
  }
  document.addEventListener('shopify:section:load', skinStickyColumns);

  /* Lazy videos: nothing downloads until the video is near the screen; plays while visible, pauses when not */
  function skinLazyVideos(root = document) {
    const videos = root.querySelectorAll('video.skin-lazy-video:not([data-lazy-ready])');
    if (!videos.length) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    videos.forEach((video) => {
      video.dataset.lazyReady = 'true';
      video.muted = true;
      video.playsInline = true;
      if (reduceMotion) video.controls = true;
    });
    if (!('IntersectionObserver' in window)) {
      videos.forEach((video) => {
        video.preload = 'auto';
        if (!reduceMotion) video.play().catch(() => {});
      });
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (video.preload === 'none') video.preload = 'auto';
            if (!reduceMotion) video.play().catch(() => {});
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );
    videos.forEach((video) => observer.observe(video));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => skinLazyVideos());
  } else {
    skinLazyVideos();
  }
  document.addEventListener('shopify:section:load', (event) => skinLazyVideos(event.target));
})();

/* Mobile gallery: fill the progress bar as the shopper swipes */
(() => {
  const skinGalleryProgress = () => {
    document.querySelectorAll('.skin-pdp--bento .product__media-wrapper').forEach((wrapper) => {
      const fill = wrapper.querySelector('.skin-gallery-progress__fill');
      const current = wrapper.querySelector('.slider-counter--current');
      const total = wrapper.querySelector('.slider-counter--total');
      if (!fill || !current || !total || fill.dataset.bound) return;
      fill.dataset.bound = 'true';
      const update = () => {
        const count = parseInt(total.textContent, 10) || 1;
        const index = Math.min(parseInt(current.textContent, 10) || 1, count);
        fill.style.setProperty('--skin-progress', `${(index / count) * 100}%`);
      };
      new MutationObserver(update).observe(current, { childList: true, characterData: true, subtree: true });
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', skinGalleryProgress);
  } else {
    skinGalleryProgress();
  }
})();

/* Product image zoom: full-screen viewer with swipe, pinch / double-tap zoom (mobile) and click-to-zoom with cursor pan (desktop) */
(() => {
  // skin-pdp.js is included by several sections; set up the viewer once
  if (window.skinZoomReady) return;
  window.skinZoomReady = true;

  const MAX_SCALE = 4;
  const TAP_SCALE = 2.5;
  const icon = (path) =>
    `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${path}</svg>`;

  let viewer;
  let track;
  let counter;
  let thumbs;
  let slides = [];
  let index = 0;
  let lastFocus;
  const zoom = { s: 1, x: 0, y: 0 };

  const imageItems = (gallery) =>
    Array.from(gallery.querySelectorAll('.product__media-item')).filter((li) =>
      li.querySelector('.media-type-image img')
    );

  const fullSrc = (img) => {
    const src = img.currentSrc || img.src;
    try {
      const url = new URL(src, window.location.href);
      if (url.searchParams.has('width')) url.searchParams.set('width', '2400');
      return url.toString();
    } catch (e) {
      return src;
    }
  };

  const build = () => {
    viewer = document.createElement('div');
    viewer.className = 'skin-zoom';
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', 'Product images');
    viewer.hidden = true;
    viewer.innerHTML = `
      <div class="skin-zoom__bar">
        <span class="skin-zoom__counter" aria-live="polite"></span>
        <span class="skin-zoom__hint"></span>
        <button type="button" class="skin-zoom__close" aria-label="Close">${icon('<path d="M6 6l12 12M18 6L6 18"/>')}</button>
      </div>
      <div class="skin-zoom__track"></div>
      <button type="button" class="skin-zoom__nav skin-zoom__nav--prev" aria-label="Previous image">${icon('<path d="M15 5l-7 7 7 7"/>')}</button>
      <button type="button" class="skin-zoom__nav skin-zoom__nav--next" aria-label="Next image">${icon('<path d="M9 5l7 7-7 7"/>')}</button>
      <div class="skin-zoom__thumbs"></div>`;
    document.body.appendChild(viewer);
    track = viewer.querySelector('.skin-zoom__track');
    counter = viewer.querySelector('.skin-zoom__counter');
    thumbs = viewer.querySelector('.skin-zoom__thumbs');
    const touch = window.matchMedia('(hover: none)').matches;
    viewer.querySelector('.skin-zoom__hint').textContent = touch ? 'Pinch or double-tap to zoom' : 'Click to zoom';

    viewer.querySelector('.skin-zoom__close').addEventListener('click', close);
    viewer.querySelector('.skin-zoom__nav--prev').addEventListener('click', () => go(index - 1));
    viewer.querySelector('.skin-zoom__nav--next').addEventListener('click', () => go(index + 1));
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('click', onClick);
    track.addEventListener('mousemove', onMouseMove);
    track.addEventListener('touchstart', onTouchStart, { passive: false });
    track.addEventListener('touchmove', onTouchMove, { passive: false });
    track.addEventListener('touchend', onTouchEnd);
    document.addEventListener('keydown', (event) => {
      if (viewer.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') go(index - 1);
      if (event.key === 'ArrowRight') go(index + 1);
    });
  };

  const activeImg = () => slides[index] && slides[index].querySelector('img');

  const apply = (animate) => {
    const img = activeImg();
    if (!img) return;
    img.style.transition = animate ? 'transform 0.3s ease' : 'none';
    img.style.transform = `translate(${zoom.x}px, ${zoom.y}px) scale(${zoom.s})`;
    viewer.classList.toggle('is-zoomed', zoom.s > 1.01);
  };

  const clamp = () => {
    const img = activeImg();
    if (!img) return;
    const maxX = ((zoom.s - 1) * img.offsetWidth) / 2;
    const maxY = ((zoom.s - 1) * img.offsetHeight) / 2;
    zoom.x = Math.max(-maxX, Math.min(maxX, zoom.x));
    zoom.y = Math.max(-maxY, Math.min(maxY, zoom.y));
  };

  const reset = (animate) => {
    zoom.s = 1;
    zoom.x = 0;
    zoom.y = 0;
    apply(animate);
  };

  // Offset of a screen point from the centre of the active image
  const fromCentre = (clientX, clientY) => {
    const img = activeImg();
    const rect = img.parentElement.getBoundingClientRect();
    return { x: clientX - (rect.left + rect.width / 2), y: clientY - (rect.top + rect.height / 2) };
  };

  const zoomAt = (clientX, clientY, scale) => {
    const d = fromCentre(clientX, clientY);
    zoom.s = scale;
    zoom.x = d.x * (1 - scale);
    zoom.y = d.y * (1 - scale);
    clamp();
    apply(true);
  };

  const update = () => {
    counter.textContent = `${index + 1} / ${slides.length}`;
    thumbs.querySelectorAll('button').forEach((button, i) => {
      button.setAttribute('aria-current', i === index ? 'true' : 'false');
      if (i === index) button.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
    viewer.querySelector('.skin-zoom__nav--prev').disabled = index === 0;
    viewer.querySelector('.skin-zoom__nav--next').disabled = index === slides.length - 1;
  };

  const go = (next, instant) => {
    if (next < 0 || next >= slides.length) return;
    if (next !== index) reset(false);
    index = next;
    track.scrollTo({ left: track.clientWidth * index, behavior: instant ? 'auto' : 'smooth' });
    update();
  };

  const onScroll = () => {
    const next = Math.round(track.scrollLeft / track.clientWidth);
    if (next !== index && next >= 0 && next < slides.length) {
      reset(false);
      index = next;
      update();
    }
  };

  // Desktop: click toggles zoom, the cursor pans
  const onClick = (event) => {
    if (window.matchMedia('(hover: none)').matches) return;
    if (!event.target.closest('.skin-zoom__frame')) return;
    if (zoom.s > 1.01) {
      reset(true);
    } else {
      zoomAt(event.clientX, event.clientY, TAP_SCALE);
    }
  };

  const onMouseMove = (event) => {
    if (zoom.s <= 1.01 || window.matchMedia('(hover: none)').matches) return;
    const d = fromCentre(event.clientX, event.clientY);
    zoom.x = d.x * (1 - zoom.s);
    zoom.y = d.y * (1 - zoom.s);
    clamp();
    apply(false);
  };

  // Mobile: pinch, pan when zoomed, double-tap
  let gesture = null;
  let lastTap = { time: 0, x: 0, y: 0 };
  const dist = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);

  const onTouchStart = (event) => {
    const t = event.touches;
    if (t.length === 2) {
      event.preventDefault();
      const mid = fromCentre((t[0].clientX + t[1].clientX) / 2, (t[0].clientY + t[1].clientY) / 2);
      gesture = { type: 'pinch', d0: dist(t[0], t[1]), s0: zoom.s, x0: zoom.x, y0: zoom.y, m0: mid };
    } else if (t.length === 1 && zoom.s > 1.01) {
      gesture = { type: 'pan', px: t[0].clientX, py: t[0].clientY, x0: zoom.x, y0: zoom.y, moved: false };
    } else {
      gesture = { type: 'tap', px: t[0].clientX, py: t[0].clientY, moved: false };
    }
  };

  const onTouchMove = (event) => {
    if (!gesture) return;
    const t = event.touches;
    if (gesture.type === 'pinch' && t.length === 2) {
      event.preventDefault();
      const mid = fromCentre((t[0].clientX + t[1].clientX) / 2, (t[0].clientY + t[1].clientY) / 2);
      const s = Math.max(1, Math.min(MAX_SCALE, (gesture.s0 * dist(t[0], t[1])) / gesture.d0));
      const qx = (gesture.m0.x - gesture.x0) / gesture.s0;
      const qy = (gesture.m0.y - gesture.y0) / gesture.s0;
      zoom.s = s;
      zoom.x = mid.x - qx * s;
      zoom.y = mid.y - qy * s;
      clamp();
      apply(false);
    } else if (gesture.type === 'pan' && t.length === 1) {
      event.preventDefault();
      gesture.moved = true;
      zoom.x = gesture.x0 + (t[0].clientX - gesture.px);
      zoom.y = gesture.y0 + (t[0].clientY - gesture.py);
      clamp();
      apply(false);
    } else if (gesture.type === 'tap' && t.length === 1) {
      if (Math.abs(t[0].clientX - gesture.px) > 10 || Math.abs(t[0].clientY - gesture.py) > 10) gesture.moved = true;
    }
  };

  const onTouchEnd = (event) => {
    if (!gesture) return;
    if (gesture.type === 'pinch' && event.touches.length < 2) {
      if (zoom.s < 1.05) reset(true);
      gesture = null;
      return;
    }
    if (event.touches.length) return;
    if (!gesture.moved && event.target.closest('.skin-zoom__frame')) {
      const now = Date.now();
      const touch = event.changedTouches[0];
      const near = Math.abs(touch.clientX - lastTap.x) < 30 && Math.abs(touch.clientY - lastTap.y) < 30;
      if (now - lastTap.time < 300 && near) {
        event.preventDefault();
        if (zoom.s > 1.01) {
          reset(true);
        } else {
          zoomAt(touch.clientX, touch.clientY, TAP_SCALE);
        }
        lastTap.time = 0;
      } else {
        lastTap = { time: now, x: touch.clientX, y: touch.clientY };
      }
    }
    gesture = null;
  };

  const open = (gallery, startItem) => {
    if (!viewer) build();
    const items = imageItems(gallery);
    if (!items.length) return false;
    const start = Math.max(0, items.indexOf(startItem));
    track.innerHTML = '';
    thumbs.innerHTML = '';
    slides = items.map((li, i) => {
      const source = li.querySelector('.media-type-image img');
      const slide = document.createElement('div');
      slide.className = 'skin-zoom__slide';
      const frame = document.createElement('div');
      frame.className = 'skin-zoom__frame';
      const img = document.createElement('img');
      img.alt = source.alt || '';
      img.decoding = 'async';
      img.draggable = false;
      img.src = fullSrc(source);
      frame.appendChild(img);
      slide.appendChild(frame);
      track.appendChild(slide);

      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.setAttribute('aria-label', `Show image ${i + 1}`);
      const small = document.createElement('img');
      small.src = source.currentSrc || source.src;
      small.alt = '';
      thumb.appendChild(small);
      thumb.addEventListener('click', () => go(i));
      thumbs.appendChild(thumb);
      return slide;
    });
    viewer.classList.toggle('skin-zoom--single', slides.length < 2);
    lastFocus = document.activeElement;
    viewer.hidden = false;
    document.documentElement.classList.add('skin-zoom-open');
    index = start;
    reset(false);
    requestAnimationFrame(() => {
      viewer.classList.add('is-open');
      go(start, true);
      viewer.querySelector('.skin-zoom__close').focus({ preventScroll: true });
    });
    return true;
  };

  const close = () => {
    if (!viewer || viewer.hidden) return;
    viewer.classList.remove('is-open', 'is-zoomed');
    document.documentElement.classList.remove('skin-zoom-open');
    setTimeout(() => {
      viewer.hidden = true;
      track.innerHTML = '';
    }, 200);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };

  // Take over Dawn's lightbox for images on the bento product page (videos keep the default player)
  document.addEventListener(
    'click',
    (event) => {
      const toggle = event.target.closest('.skin-pdp--bento .product__media-toggle');
      if (!toggle) return;
      const item = toggle.closest('.product__media-item');
      const gallery = toggle.closest('media-gallery');
      if (!item || !gallery || !item.querySelector('.media-type-image')) return;
      event.preventDefault();
      event.stopPropagation();
      open(gallery, item);
    },
    true
  );
})();

/* Bag: fade a line out as it is removed, and fade the bag contents out when the last item goes,
   so the empty state can animate in cleanly once the drawer re-renders */
(() => {
  if (window.skinCartRemoveReady) return;
  window.skinCartRemoveReady = true;

  const markRemoving = (row) => {
    if (!row || row.classList.contains('is-removing')) return;
    row.classList.add('is-removing');
    const list = row.closest('cart-drawer-items, cart-items');
    if (!list) return;
    const remaining = list.querySelectorAll('.cart-item:not(.is-removing)').length;
    if (remaining === 0) {
      const inner = row.closest('.drawer__inner');
      if (inner) inner.classList.add('is-emptying');
      const page = document.getElementById('main-cart-items');
      if (page && page.contains(row)) document.body.classList.add('skin-cart-emptying');
    }
  };

  const clear = () => {
    setTimeout(() => {
      document.querySelectorAll('.drawer__inner.is-emptying').forEach((el) => el.classList.remove('is-emptying'));
      document.querySelectorAll('.cart-item.is-removing').forEach((el) => el.classList.remove('is-removing'));
      document.body.classList.remove('skin-cart-emptying');
    }, 60);
  };

  document.addEventListener(
    'click',
    (event) => {
      const remove = event.target.closest('cart-remove-button, .cart-remove-button');
      if (remove) return markRemoving(remove.closest('.cart-item'));
      const minus = event.target.closest('.cart-item .quantity__button[name="minus"]');
      if (minus) {
        const input = minus.parentElement.querySelector('.quantity__input');
        if (input && Number(input.value) <= 1) markRemoving(minus.closest('.cart-item'));
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest('.cart-item .quantity__input');
      if (input && Number(input.value) === 0) markRemoving(input.closest('.cart-item'));
    },
    true
  );

  const hook = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, clear);
    subscribe(PUB_SUB_EVENTS.cartError, clear);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook);
  else hook();
})();
